// Indices de zona horaria aceptados por NTP.TimeZone del firmware Dahua V3.98.
// Lista extraida del manual seccion 4.8.11 (40 opciones, 0-39).
// El indice 24 corresponde a Chile/Santiago (GMT-04:00).

export interface TimeZoneOption {
  value: number;
  label: string;
  hint?: string;
}

export const TIMEZONES: TimeZoneOption[] = [
  { value: 32, label: "GMT-12:00" },
  { value: 31, label: "GMT-11:00" },
  { value: 30, label: "GMT-10:00" },
  { value: 36, label: "GMT-09:30" },
  { value: 29, label: "GMT-09:00" },
  { value: 28, label: "GMT-08:00", hint: "Los Ángeles" },
  { value: 27, label: "GMT-07:00", hint: "Denver, Phoenix" },
  { value: 26, label: "GMT-06:00", hint: "Ciudad de México, Costa Rica" },
  { value: 25, label: "GMT-05:00", hint: "Bogotá, Lima, Nueva York" },
  { value: 33, label: "GMT-04:30" },
  { value: 24, label: "GMT-04:00", hint: "Santiago, Caracas, La Paz" },
  { value: 23, label: "GMT-03:30" },
  { value: 22, label: "GMT-03:00", hint: "Buenos Aires, São Paulo, Montevideo" },
  { value: 21, label: "GMT-02:00" },
  { value: 20, label: "GMT-01:00" },
  { value: 0,  label: "GMT+00:00", hint: "Londres, Lisboa" },
  { value: 1,  label: "GMT+01:00", hint: "Madrid, Roma, Berlín" },
  { value: 2,  label: "GMT+02:00", hint: "Atenas, El Cairo" },
  { value: 3,  label: "GMT+03:00", hint: "Moscú, Estambul" },
  { value: 4,  label: "GMT+03:30" },
  { value: 5,  label: "GMT+04:00" },
  { value: 6,  label: "GMT+04:30" },
  { value: 7,  label: "GMT+05:00" },
  { value: 8,  label: "GMT+05:30" },
  { value: 9,  label: "GMT+05:45" },
  { value: 10, label: "GMT+06:00" },
  { value: 11, label: "GMT+06:30" },
  { value: 12, label: "GMT+07:00" },
  { value: 13, label: "GMT+08:00", hint: "Beijing, Hong Kong" },
  { value: 37, label: "GMT+08:30" },
  { value: 38, label: "GMT+08:45" },
  { value: 14, label: "GMT+09:00", hint: "Tokio, Seúl" },
  { value: 15, label: "GMT+09:30" },
  { value: 16, label: "GMT+10:00", hint: "Sídney" },
  { value: 34, label: "GMT+10:30" },
  { value: 17, label: "GMT+11:00" },
  { value: 18, label: "GMT+12:00" },
  { value: 39, label: "GMT+12:45" },
  { value: 19, label: "GMT+13:00" },
  { value: 35, label: "GMT+14:00" },
];

export function timezoneLabel(value: number): string {
  const tz = TIMEZONES.find(t => t.value === value);
  if (!tz) return `Índice ${value}`;
  return tz.hint ? `${tz.label} — ${tz.hint}` : tz.label;
}

// Preset Chile estandar para DST: inicio en septiembre 1er domingo, fin en abril 1er domingo.
// Esto coincide con la regla observada en el NVR real `192.168.10.118` (firmware 4.003).
export const DST_PRESET_CHILE = {
  Enable: true,
  Start: { Year: 0, Month: 9, Week: 1, Day: 0, Hour: 0, Minute: 0 },
  End:   { Year: 0, Month: 4, Week: 1, Day: 0, Hour: 0, Minute: 0 },
};
